// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-3TM6bw-y","title_box":"title_box-3YHL7jYa","pic_box":"pic_box-18hCygMy"};